import {
  ClaimBookingResult,
  MatchedReservationDetails,
  MatchingClient,
  SelectedSailorData,
  StepData,
} from '../types/ClaimBookingTypes';
import { LookupBookingForClaimResult } from '../types/LookupBookingForClaimTypes';

export const addFirstNameToUserData = (value: SelectedSailorData, firstName?: string) => {
  if (!value.user || value.user.firstName || !firstName) return value;

  return {
    ...value,
    user: {
      ...value.user,
      firstName,
    },
  };
};

export const getSelectedSailor = (
  sailors?: MatchingClient[],
  selectedSailorClientId?: string,
): MatchingClient | undefined => {
  if (!selectedSailorClientId) return undefined;

  if (!sailors || sailors.length === 0) return undefined;

  return sailors?.find((sailor) => sailor?.clientId === selectedSailorClientId);
};

export const getCurrentClaimedSailor = (
  stepData: StepData,
  selectedSailorDataOverride?: SelectedSailorData | StepData | null,
): MatchingClient | undefined => {
  const sailorData = selectedSailorDataOverride ?? stepData.selectedSailorData;
  const selectedClientId =
    sailorData?.user?.clientID ||
    (sailorData as StepData)?.selectedSailorData?.user?.clientID ||
    stepData?.sailors?.[0]?.clientId;

  return getSelectedSailor(stepData?.sailors, selectedClientId);
};

export const prepareReservationDetails = (reservationDetails?: MatchedReservationDetails) => {
  if (!reservationDetails) return null;

  const { __typename, ...detailsWithoutTypename } = reservationDetails;

  return detailsWithoutTypename;
};

export const prepareClaimPayload = (value: SelectedSailorData, stepData: StepData) => {
  const reservationDetailsWithoutType = prepareReservationDetails(stepData?.reservationDetails);
  const valueWithFirstName = addFirstNameToUserData(value, stepData.firstName);

  return {
    noOfGuestsInput: stepData?.noOfGuests,
    ...valueWithFirstName,
    blankEmailCheckEnabled: true,
    ...(reservationDetailsWithoutType ? { reservationDetails: reservationDetailsWithoutType } : {}),
  };
};

export const mapLookupToClaimResult = (result: LookupBookingForClaimResult): ClaimBookingResult => ({
  status: result.status || ('' as unknown as ClaimBookingResult['status']),
  sailors:
    result.sailors?.map((sailor) => ({
      id: sailor.id,
      clientId: sailor.clientId,
      name: sailor.name,
      email: sailor.email,
      phone: sailor.phone,
      dob: sailor.dob,
      sex: sailor.sex,
      citizenship: sailor.citizenship,
    })) || [],
  reservationDetails: result.reservationDetails,
  noOfGuests: result.noOfGuests,
});

export const mapSailorToSelectedSailorData = (sailor: MatchingClient, bookingNumber: string): SelectedSailorData => ({
  bookingNumber,
  matchingClientId: sailor.id,
  user: {
    clientID: sailor.clientId,
    lastName: sailor.name?.last,
    birthday: sailor.dob,
  },
});
